import { call, put, select, spawn } from 'typed-redux-saga';

import { isMessengerIntegration, selectIsTeleMessenger } from '../../../../shared/features/config/selectors';
import { feedbackSaga } from '../../../../shared/features/feedback/sagas/feedbackSaga';
import { NOTIFICATIONS_MAP, notify } from '../../../../shared/features/notifications/ps-notifications';
import { selectIsUserB2BDomainMismatch } from '../../../../shared/features/user/selectors';
import { replace, SCREENS } from '../../../../shared/helpers/navigation';
import { disconnectConferenceAction, setCloseRoomInitiatedBySelf } from '../../features/conference/slice';
import { selectCloseRoomInitiatedBySelf } from '../../selectors';
import { DisconnectReason, NotificationId } from '../../types';
import { shouldShowRoomWasClosedNotification } from './close-room-notification';
import { handleDisconnect } from './handle-disconnect';

export function* handleCloseRoom() {
    const closeRoomInitiatedBySelf = yield* select(selectCloseRoomInitiatedBySelf);
    const isUserDomainMismatch = yield* select(selectIsUserB2BDomainMismatch);
    const isMessenger = yield* select(isMessengerIntegration);
    const isTeleMessenger = yield* select(selectIsTeleMessenger);

    if (!isUserDomainMismatch && !isMessenger && !isTeleMessenger) {
        yield* spawn(feedbackSaga);
    }

    yield* put(
        disconnectConferenceAction({
            source: DisconnectReason.CLOSE_ROOM,
        })
    );

    yield* call(replace, SCREENS.CREATE_CALL, {});
    yield* call(handleDisconnect);
    yield* put(setCloseRoomInitiatedBySelf(false));

    if (shouldShowRoomWasClosedNotification(closeRoomInitiatedBySelf)) {
        yield* put(notify(NOTIFICATIONS_MAP[NotificationId.PERMISSIONS_CLOSE_ROOM]()));
    }
}
